/**
 * Created by Ning Jiang on 2024-01-10.
 */

import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {ElGordosRevengeReelController} from "./ElGordosRevengeReelController";
import {ElGordosRevengeSymbolState} from "../symbol/ElGordosRevengeSymbolConfig";
import {ElGordosRevengeSymbol} from "../symbol/ElGordosRevengeSymbol";
import {EGRStackedSymbol} from "../symbol/EGRStackedSymbol";
import {EGRS2Symbol} from "../symbol/EGRS2Symbol";

export class EGRLastReelController extends ElGordosRevengeReelController {

    constructor() {
        super(5);
    }

    public createSymbol(symName:string, reelId:number, state:ElGordosRevengeSymbolState):ElGordosRevengeSymbol {
        if(symName.includes("S2")) {
            return new EGRS2Symbol(symName, this.reelId, state);
        }

        return new EGRStackedSymbol(symName, this.reelId, state);
    }

    protected makeUpStopReelSetRandomFillUp(length:number):string[] {
        let result:string[] = [];
        while(result.length < length) {
            const randomSymbol = ArrayHelper.getRandomValue(["M1D", "M2D", "M3D", "M4D", "M5D"]);
            result = result.concat([`${randomSymbol}*0`, `${randomSymbol}*1`]);
        }
        return result;
    }
}